"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
exports.default = (theme) => core_1.createStyles({
    pagination: {
        display: 'flex',
        justifyContent: 'left',
    },
    actionsCol: {
        width: theme.spacing(7),
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
    actionsButton: {
        float: 'right',
    },
    thumbnail: {
        maxWidth: 60,
        maxHeight: 60,
    },
    thumbnailWrapper: {
        width: 1,
        paddingRight: theme.spacing(2),
        textAlign: 'center',
    },
    thumbnailRowWrapper: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        lineHeight: 0,
    },
});
//# sourceMappingURL=Table.styles.js.map